import React, { useState, useCallback, useEffect } from 'react'
import {
  FareTableDispatchContext,
  FareTableStateContext
} from '../contexts/fareTableData'
import Layout from '../components/layout'
import FareTable from '../components/fareTable/fareTable'
import Translator from '../components/Translation/Translator'


const CheapFlightsPage = () => {
  const [fareTableData, setFareTableData] = useState([])
  const [fareDataForTop, setfareDataForTop] = useState(null)

  //----------------tranlation code--------------
  const [sessionActiveLang, setSessionActiveLang] = useState();
  const [ActiveLanguage, setActiveLanguage] = useState()

  const setSessionLang = useCallback(() => {
    if (window.sessionStorage.getItem('sessionActiveLang'))
      setSessionActiveLang(window.sessionStorage.getItem('sessionActiveLang') ?
        window.sessionStorage.getItem('sessionActiveLang') : window.localStorage.getItem("ActiveLang") ?
          window.localStorage.getItem("ActiveLang") : "es")
  })

  useEffect(() => {
    setActiveLanguage(window.sessionStorage.getItem('sessionActiveLang') ?
      window.sessionStorage.getItem('sessionActiveLang') :
      window.localStorage.getItem("ActiveLang") ?
        window.localStorage.getItem("ActiveLang") : "es");
  })

  function Convert(text) {
    if (sessionActiveLang && sessionActiveLang === 'es') return Translator.Translation[`${text}`];
    else if (ActiveLanguage === "es") return Translator.Translation[`${text}`];
    else return text;
  }

  //-----------------end-------------

  //----------------topbanner- upto off code --------
  useEffect(() => {
    if (fareTableData.length > 0)
      setfareDataForTop(fareTableData[0])
    else setfareDataForTop(null)
  }, [fareTableData])
  //-----------------end-------------


  return (
    <FareTableDispatchContext.Provider value={setFareTableData}>
      <FareTableStateContext.Provider value={fareTableData} >
        <Layout fareDataForTop={fareDataForTop} ActiveLanguageCF={ActiveLanguage} ConvertCF={Convert} setSessionLangCF={setSessionLang} >
          <FareTable Convert={Convert} ActiveLanguage={ActiveLanguage} sessionActiveLang={sessionActiveLang} mainCityName={fareDataForTop} />
        </Layout>
      </FareTableStateContext.Provider>
    </FareTableDispatchContext.Provider>
  )
}

export default CheapFlightsPage
